import { render, staticRenderFns } from "./InteractiveTags.vue?vue&type=template&id=aeba4380&"
import script from "./InteractiveTags.vue?vue&type=script&lang=js&"
export * from "./InteractiveTags.vue?vue&type=script&lang=js&"
import style0 from "./InteractiveTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports